// DEPRECATED (Phase 7): The old breakdown/reporting flows are deprecated.
// All new issue reports must use the unified Ticketing System
// (`/tickets/new` or `TicketCreateForm`). This route now redirects to the
// unified Create Ticket flow. When called with `?asset=<code>` we forward to
// the asset-scoped variant after resolving the code to an asset id.
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { apiGet } from "@/integrations/api/client";

const searchSchema = z.object({ asset: z.string().optional() });

export const Route = createFileRoute("/_authenticated/work-orders/new")({
  validateSearch: (s) => searchSchema.parse(s),
  beforeLoad: async ({ search }) => {
    if (search.asset) {
      let code = search.asset;
      try { code = decodeURIComponent(code); } catch { /* keep raw */ }
      try {
        const res = await apiGet<any>("/api/v1/assets/", { search: code });
        const asset = (res?.results ?? []).find((a: any) => a.asset_code === code || a.qr_code === code);
        if (asset?.id) {
          throw redirect({
            to: "/assets/$assetId/report-issue",
            params: { assetId: asset.id },
            search: { source: "Manual" } as never,
          });
        }
      } catch (e) {
        if ((e as any)?.to) throw e;
      }
    }
    throw redirect({ to: "/tickets/new" });
  },
  component: () => null,
});
